<template lang="html">
  <div class="flex flex-col h-full">
    <div class="flex align-baseline justify-between">
      <div class="text-lg font-medium flex items-end">
        <div>Photos</div>
      </div>
      <div class="flex" :class="ultraWide ? 'w-1/2 space-x-2' : 'w-2/3'">
      <div :class="ultraWide ? 'flex-grow' : 'w-full'"
	      v-if="!isDirector">
        <label for="select_test"></label>
        <select name="stills" id="select_test" class="form-input"
                v-model="selected_stills" v-on:change="loadStills()">
          <option value="none">Select a folder...</option>
          <option value="new_folder" v-if="!ultraWide">Create a new folder</option>
          <option value="upload_folder" v-if="!ultraWide">Upload a folder</option>
          <option :value="still_folder.id" v-for="still_folder in stills_folders">{{ still_folder.name }}</option>
        </select>
      </div>
      <button class="btn btn-secondary" v-if="ultraWide" @click="showCreateFolderModal">
	 Create a new folder
      </button>
      <button class="btn btn-secondary" v-if="ultraWide" @click="showUploadFolderModal">
          Upload a folder
      </button>
      </div>
    </div>
    <div class="overflow-y-scroll bg-gray-50 dark:bg-gray-800 rounded-lg shadow-inner p-2 mt-2 relative flex-grow">
      <div v-if="stills.length">
        <transition-group name="slide-in" class="grid" :class="gridSize">
          <button class="slide-in-item w-12 h-12 relative rounded-md overflow-hidden"
                  @click="renderStillLightbox(still)" v-for="still in stills" v-bind:key="still.title + '_' + still.id">
            <img :src="still.url" :alt="still.title" class="rounded-md h-12 w-12 bg-gray-500 object-cover">
            <div
                class="absolute opacity-0 hover:opacity-50 top-0 left-0 transition w-full h-full flex items-center justify-center font-medium bg-gray-900 text-white">
              <div class="truncate">
                {{ still.title }}
              </div>
            </div>
          </button>
          <button @click="showUploadPictureModal = true"
                  class="slide-in-item w-12 h-12 flex items-center justify-center hover:text-blue-100 text-blue-700 hover:bg-blue-500 bg-blue-200 rounded-md"
                  v-bind:key="'add-button'" v-if="!isDirector">
            <!-- Upload cloud icon -->
            <svg class="h-8 w-8 fill-current" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                 viewBox="0 0 24 24">
              <path fill-rule="evenodd"
                    d="M11 4C8.79082 4 7 5.79085 7 8C7 8.03242 7.00047 8.06627 7.00131 8.10224C7.01219 8.56727 6.70099 8.97839 6.25047 9.09416C4.95577 9.42685 4 10.6031 4 12C4 13.6569 5.34317 15 7 15H8C8.55228 15 9 15.4477 9 16C9 16.5523 8.55228 17 8 17H7C4.23861 17 2 14.7614 2 12C2 9.93746 3.2482 8.16845 5.02926 7.40373C5.32856 4.36995 7.88746 2 11 2C13.2236 2 15.1629 3.20934 16.199 5.00324C19.4207 5.10823 22 7.75289 22 11C22 14.3137 19.3138 17 16 17C15.4477 17 15 16.5523 15 16C15 15.4477 15.4477 15 16 15C18.2092 15 20 13.2091 20 11C20 8.79085 18.2092 7 16 7C15.8893 7 15.78 7.00447 15.6718 7.01322C15.2449 7.04776 14.8434 6.8066 14.6734 6.4135C14.0584 4.99174 12.6439 4 11 4ZM11.2929 9.29289C11.6834 8.90237 12.3166 8.90237 12.7071 9.29289L14.7071 11.2929C15.0976 11.6834 15.0976 12.3166 14.7071 12.7071C14.3166 13.0976 13.6834 13.0976 13.2929 12.7071L13 12.4142V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V12.4142L10.7071 12.7071C10.3166 13.0976 9.68342 13.0976 9.29289 12.7071C8.90237 12.3166 8.90237 11.6834 9.29289 11.2929L11.2929 9.29289Z"
                    clip-rule="evenodd"/>
            </svg>
          </button>
          <button @click="showDeleteConfirmation = true"
                  class="slide-in-item w-12 h-12 flex items-center justify-center hover:text-red-100 text-red-700 hover:bg-red-500 bg-red-200 rounded-md"
                  v-bind:key="'delete-button'" v-if="!isDirector && !isInHost">
            Delete folder
          </button>
        </transition-group>
      </div>
      <div class="text-gray-600 dark:text-gray-400 flex justify-center items-center h-full" v-if="stills.length == 0 && !isLoading">
        <div class="text-center">
          <span v-if="selected_stills != 'none'">
            Empty folder
            <button data-e2e="upload_test" class="block mt-5 btn btn-sm btn-secondary"
                    @click="showUploadPictureModal = true" v-if="!isDirector">Upload your first photo!
            </button>
            <button class="mt-10 hover:text-red-600" @click="showDeleteConfirmation = true" v-if="!isDirector">Delete
              folder
            </button>
          </span>
          <span v-else>
            No folder selected
          </span>
        </div>
      </div>
      <div class="text-gray-600 flex justify-center items-center h-full" v-if="isLoading">
        <div class="text-center">
          <div class="loader mx-auto mb-2"></div>
          Loading...
        </div>
      </div>
      <div class="absolute bottom-0 w-full flex justify-center" v-show="!isDirector">
        <button class="text-gray-400 hover:text-red-600"></button>
      </div>
    </div>
    <modal :show-modal="showDeleteConfirmation" @close="showDeleteConfirmation = false">
      <div class="mt-3 text-center sm:mt-5">
        <h1>
          You are about to delete the folder
        </h1>
        <h3 class="leading-6 font-medium text-red-600" id="modal-headline">
          This action is irreversible.
        </h3>
      </div>
      <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
        <button type="button" class="btn btn-primary" @click="showDeleteConfirmation = false;">
          Close
        </button>
        <button type="button" class="btn bg-gray-200 text-red-600 hover:bg-red-600 hover:text-white"
                @click="deleteStillFolder(selected_stills)">
          Delete
        </button>
      </div>
    </modal>
    <modal :showModal="showLightbox" @close="closeLightbox()" classSize="sm:max-w-2xl">
      <div class="pt-4 md:pt-2">
        <div class="hidden md:block text-center -mt-4 pb-2">
        To speak while keeping your eyes on this graphic, press and hold the space bar
        </div>
        <img :src="selected_still.url" class="w-auto mx-auto min-h-screen-6/10 max-h-screen-8/10 object-contain" id="lightboxImage"/>
        <div class="mt-3 text-center sm:mt-5">
          <h3 class="text-lg leading-6 font-medium dark:text-gray-100 text-gray-900" id="modal-headline">
            {{ selected_still.title }}
          </h3>
        </div>
      </div>
      <div class="mt-4 grid gap-3 grid-flow-row-dense px-2" :class="isDirector ? 'grid-cols-1' :'grid-cols-2'">
        <button type="button" class="btn" @click="presentStill()" v-show="!isDirector" :disabled="presentationMode" :class="presentationMode ? 'btn-disabled' : 'btn-primary'">
          {{ presentationMode ? 'Showing to everybody' : 'Show to everybody' }}
        </button>
        <button type="button" class="btn btn-secondary" @click="closeLightbox()">
          Close
        </button>
      </div>
    </modal>
    <modal :showModal="showUploadPictureModal" @close="showUploadPictureModal = false">
      <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
        <!-- Upload cloud icon -->
        <svg class="h-6 w-6 text-green-600 fill-current" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
             viewBox="0 0 24 24">
          <path fill-rule="evenodd"
                d="M11 4C8.79082 4 7 5.79085 7 8C7 8.03242 7.00047 8.06627 7.00131 8.10224C7.01219 8.56727 6.70099 8.97839 6.25047 9.09416C4.95577 9.42685 4 10.6031 4 12C4 13.6569 5.34317 15 7 15H8C8.55228 15 9 15.4477 9 16C9 16.5523 8.55228 17 8 17H7C4.23861 17 2 14.7614 2 12C2 9.93746 3.2482 8.16845 5.02926 7.40373C5.32856 4.36995 7.88746 2 11 2C13.2236 2 15.1629 3.20934 16.199 5.00324C19.4207 5.10823 22 7.75289 22 11C22 14.3137 19.3138 17 16 17C15.4477 17 15 16.5523 15 16C15 15.4477 15.4477 15 16 15C18.2092 15 20 13.2091 20 11C20 8.79085 18.2092 7 16 7C15.8893 7 15.78 7.00447 15.6718 7.01322C15.2449 7.04776 14.8434 6.8066 14.6734 6.4135C14.0584 4.99174 12.6439 4 11 4ZM11.2929 9.29289C11.6834 8.90237 12.3166 8.90237 12.7071 9.29289L14.7071 11.2929C15.0976 11.6834 15.0976 12.3166 14.7071 12.7071C14.3166 13.0976 13.6834 13.0976 13.2929 12.7071L13 12.4142V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V12.4142L10.7071 12.7071C10.3166 13.0976 9.68342 13.0976 9.29289 12.7071C8.90237 12.3166 8.90237 11.6834 9.29289 11.2929L11.2929 9.29289Z"
                clip-rule="evenodd"/>
        </svg>
      </div>
      <div class="mt-3 text-center sm:mt-5">
        <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
          Upload a new still
        </h3>
        <div class="mt-2">
          <p class="text-sm text-gray-500">
            Upload a new still to the folder.  The new still will be updated automatically.
          </p>
        </div>
      </div>
      <div class="mt-5">
        <label class="font-bold">Title</label>
        <input type="text" class="form-input" placeholder="Title for the still" v-model="new_still_name">
        <label class="font-bold mt-2">Upload a file</label>
        <input type="file" ref="user_upload" accept="image/*" class="form-input" id="takeName"
               v-on:change="handleFileUploaded($event)">

        <label class="font-bold mt-4" v-show="preview_upload">Preview</label>
        <img :src="preview_upload" class="w-1/2 mx-auto rounded-md" v-show="preview_upload"/>
        <span v-show="fileSizeInvalid" class="text-red-600">The file you selected is larger than {{ fileLimitInMB }}MB.
          Please, upload files smaller than {{ fileLimitInMB }}MB to ensure a good experience.</span>
      </div>
      <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
        <button type="button" class="btn sm:col-start-2 sm:text-sm" @click="uploadStill"
                :class="{'btn-primary': uploadStillValidations, 'btn-disabled': !uploadStillValidations}"
                :disabled="!uploadStillValidations">
          Upload still
        </button>
        <button type="button" class="btn btn-secondary"
                @click="showUploadPictureModal = false;">
          Cancel
        </button>
      </div>
    </modal>
     <modal :showModal="showFolderUploadModal" @close="showFolderUploadModal = false">
      <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
        <!-- Folder add icon -->
        <svg class="h-6 w-6 fill-current text-green-600" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
             fill="none" viewBox="0 0 24 24">
          <path fill-rule="evenodd"
                d="M2 6C2 4.89543 2.89543 4 4 4H9C9.26522 4 9.51957 4.10536 9.70711 4.29289L11.4142 6H20C21.1046 6 22 6.89543 22 8V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V6ZM8.58579 6L4 6V18H20V8H11C10.7348 8 10.4804 7.89464 10.2929 7.70711L8.58579 6ZM12 10C12.5523 10 13 10.4477 13 11V12H14C14.5523 12 15 12.4477 15 13C15 13.5523 14.5523 14 14 14H13V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V14H10C9.44772 14 9 13.5523 9 13C9 12.4477 9.44772 12 10 12H11V11C11 10.4477 11.4477 10 12 10Z"
                clip-rule="evenodd"/>
        </svg>
      </div>
      <div class="mt-3 text-center sm:mt-5">
        <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
          Upload a photos folder
        </h3>
      </div>
      <input type="hidden" class="form-input" placeholder="Name for the new folder" v-model="new_stills_folder_name" data-e2e="name_folder_test">
      <div class="flex justify-center">
        <div class="w-1/3 px-4 mt-5">
          <input class="folder-input w-full" id="inputStillFolder" type="file" multiple
                 @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length"
                 webkitdirectory mozdirectory accept="image/*">
        </div>
      </div>

      <div>
        <table class="w-full mt-5">
          <tbody>
          <tr v-for="(fd, i) in filesData">
            <td class="mt-1 flex flex-wrap">
              <div class="w-1/4 px-4 h-12 overflow-hidden">
                <img :id="'frameUploaded_'+i" src="" class="min-w-full min-h-full rounded-md"/>
              </div>
              <div class="w-3/4 flex flex-wrap">
                <div class="w-full px-2">
                  <input type="text" :name="'names_'+i" v-model="filesNames[i]" placeholder="Frame 1"
                         class="h-12 form-input">
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
        <button type="button" @click="createFolder" class="btn  sm:col-start-2 overflow-hidden sm:text-sm"
                data-e2e="create_stills_folder"
                :class="{'btn-primary': createFolderValidations, 'btn-disabled': !createFolderValidations}"
                :disabled="!createFolderValidations">
          Upload {{ new_stills_folder_name }}
        </button>

        <button type="button" class="btn btn-secondary" @click="showFolderUploadModal = false;">
          Cancel
        </button>
      </div>
    </modal>
    <modal :showModal="showFolderCreateModal" @close="showFolderCreateModal = false">
      <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
        <!-- Folder add icon -->
        <svg class="h-6 w-6 fill-current text-green-600" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
             fill="none" viewBox="0 0 24 24">
          <path fill-rule="evenodd"
                d="M2 6C2 4.89543 2.89543 4 4 4H9C9.26522 4 9.51957 4.10536 9.70711 4.29289L11.4142 6H20C21.1046 6 22 6.89543 22 8V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V6ZM8.58579 6L4 6V18H20V8H11C10.7348 8 10.4804 7.89464 10.2929 7.70711L8.58579 6ZM12 10C12.5523 10 13 10.4477 13 11V12H14C14.5523 12 15 12.4477 15 13C15 13.5523 14.5523 14 14 14H13V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V14H10C9.44772 14 9 13.5523 9 13C9 12.4477 9.44772 12 10 12H11V11C11 10.4477 11.4477 10 12 10Z"
                clip-rule="evenodd"/>
        </svg>
      </div>
      <div class="mt-3 text-center sm:mt-5">
        <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
          Create a photos folder
        </h3>
        <div class="mt-2">
          <p class="text-sm text-gray-500">
          Create a folder where you will be able to add pictures.
          </p>
        </div>
      </div>
      <label class="font-bold mt-5">Name of the folder</label>
      <input type="text" class="form-input" placeholder="Name for the new folder"
             v-model="new_stills_folder_name" data-e2e="name_folder_test">

      <div>
        <table class="w-full mt-5">
          <tbody>
          <tr v-for="(fd, i) in filesData">
            <td class="mt-1 flex flex-wrap">
              <div class="w-1/4 px-4 h-12 overflow-hidden">
                <img :id="'frameUploaded_'+i" src="" class="min-w-full min-h-full rounded-md"/>
              </div>
              <div class="w-3/4 flex flex-wrap">
                <div class="w-full px-2">
                  <input type="text" :name="'names_'+i" v-model="filesNames[i]" placeholder="Frame 1"
                         class="h-12 form-input">
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
        <button type="button" @click="createFolder" class="btn  sm:col-start-2 overflow-hidden sm:text-sm"
                data-e2e="create_stills_folder"
                :class="{'btn-primary': createFolderValidations, 'btn-disabled': !createFolderValidations}"
                :disabled="!createFolderValidations">
          Create {{ new_stills_folder_name }}
        </button>

        <button type="button" class="btn btn-secondary" @click="showFolderCreateModal = false;">
          Cancel
        </button>
      </div>


    </modal>
  </div>
</template>
<script>

import axios from 'axios';
import messageBroker from 'general/messageBroker';
import {localNotify} from 'utils/notifications';
import {addTask} from 'utils/status-indicator';

import commandsManager from 'general/CommandsManager'

export default {
  props: {
    isDirector: {
      type: Boolean,
      required: false,
      default: false
    },
    gridSize: {
      type: String,
      required: false,
      default: 'gap-2 grid-cols-4'
    },
    isInHost: {
      type: Boolean,
      required: false,
      default: false
    },
    isMirrorPlus: {
      type: Boolean,
      required: false,
      default: true
    },
  },
  data() {
    return {
      showLightbox: false,
      isLoading: false,
      selected_still: {},
      selected_stills: "none",
      roomActivated: false,
      stills: [],
      stills_folders: [],
      new_still_name: '',
      new_stills_folder_name: '',
      showUploadPictureModal: false,
      showFolderUploadModal: false,
      showFolderCreateModal: false,
      preview_upload: null,
      showDeleteConfirmation: false,
      fileSizeInvalid: false,
      fileLimitInMB: 10,
      formData: {
        type: FormData
      },
      filesData: [],
      filesNames: [],
      uploadTask: {},

      presentationMode: false,
	    ultraWide: false
    }
  },
  methods: {
    fileSizeIsValid(file) {
      return (file.size / 1024) / 1024 <= this.fileLimitInMB;
    },
    // add a validator
    // show a preview of image
    handleFileUploaded(event) {
      if (event.target.files.length == 0) {
        // remove picture
        this.preview_upload = null;
        return;
      }
      let file = event.target.files[0];

      this.fileSizeInvalid = !this.fileSizeIsValid(file);
      if (this.fileSizeInvalid) {
        this.preview_upload = null;
        return;
      }

      let previewURL = URL.createObjectURL(file);
      this.preview_upload = previewURL;
    },
    uploadStill() {
      // validations
      if (!this.uploadStillValidations) return;

      this.uploadTask = addTask({
        id: 'UPLOAD_STILL',
        determinate: true,
        message: 'Uploading still...'
      })

      let file = this.$refs.user_upload.files[0];
      if (this.fileSizeIsValid(file) == false) return;

      let url = "/stills_folders/" + this.selected_stills + "/stills"

      let formData = new FormData();
      formData.append('authenticity_token', authenticity_token);
      formData.append('title', this.new_still_name);
      formData.append('file', file);

      axios.post(url, formData, {
        headers: {'Content-Type': 'multipart/form-data'},
        onUploadProgress: progressEvent => {
          if (progressEvent.lengthComputable) {
            this.uploadTask.update(parseInt(progressEvent.loaded / progressEvent.total, 10) * 100);
          }
          if ((progressEvent.loaded / progressEvent.total) === 1) {
            // finished upload
          }
        }
      })
      .then(response => {
          this.showUploadPictureModal = false;
          this.loadStills()
          this.new_still_name = ""
          document.getElementById("inputStillFolder").value = "";
          this.uploadTask.done();
      }).catch(err => {
        this.uploadTask.error();
      });
    },
    filesChange(fieldName, fileList) {
      this.formData = new FormData();
      this.filesData = [];
      this.filesNames = [];
      Array
          .from(Array(fileList.length).keys())
          .map(x => {
            const file = Array.from(fileList).sort((a, b) => a.name.localeCompare(b.name))[x];
            if (file.size > this.fileLimitInMB * 1024 * 1024) return;
            this.formData.append('files[]', file, file.name);
            this.filesData.push(file);
            this.filesNames.push(file.name.split('.')[0]);

            const relativePath = file.webkitRelativePath;
            const folder = relativePath.split("/");
            this.new_stills_folder_name = folder[0];
          });
      this.filesData.forEach((x, i) => {
        let reader = new FileReader();
        reader.onload = function (e) {
          // get loaded data and render thumbnail.
          document.getElementById("frameUploaded_" + i).src = e.target.result;
        };
        // read the image file as a data URL.
        reader.readAsDataURL(x);
      })
    },
    loadStillsFolders() {
      this.isLoading = true;
      const headers = {'Accept': 'application/json'};
      axios.get('/stills_folders', {headers}).then(response => {
        this.stills_folders = response.data;
        this.isLoading = false;
        if (!this.roomActivated) this.selected_stills = this.stills_folders[0].id
        this.loadStills();
      }).catch(err => {
        this.stills_folders = [];
        this.isLoading = false;
      });
    },
    showCreateFolderModal(){
        // show the Create Stills Folder modal and set to none selector
        this.selected_stills = 'none'
        // ensure that the array is regenerated
        this.formData = new FormData();
        this.loadStills()
        this.showFolderCreateModal = true;
    },
    showUploadFolderModal(){
        // show the Upload Stills Folder modal and set to none selector
        this.selected_stills = 'none'
        // ensure that the array is regenerated
        this.formData = new FormData();
        this.loadStills()
        this.showFolderUploadModal = true;
    },

    loadStills(event) {
      if (this.selected_stills == 'new_folder') {
	this.showCreateFolderModal();
	return;
      }
      if (this.selected_stills == 'upload_folder') {
	this.showUploadFolderModal();
        return;
      }
      if (this.selected_stills == 'none') {
        this.stills = [];
        return;
      }
      let url = "/stills_folders/" + this.selected_stills + "/stills"
      this.isLoading = true;
      axios.get(url).then(response => {
        this.stills = response.data;
        this.isLoading = false;
        commandsManager.sendAllCommand('set_stills', this.stills);
      }).catch(err => {
        this.stills = [];
        this.isLoading = false;
      });

    },
    createFolder() {
      this.uploadTask = addTask({id: 'UPLOAD_STILLS_FOLDER',
        determinate: true,
        message: 'Uploading stills folder...'
      })

      // validations
      if (!this.createFolderValidations) return;

      let url = '/stills_folders/upload'
      //let formData = new FormData();
      this.formData.append('authenticity_token', authenticity_token);
      this.formData.append('name', this.new_stills_folder_name);

      this.filesNames.forEach(x => {
        this.formData.append('file_names[]', x);
      })

      axios.post(url, this.formData, {
        onUploadProgress: progressEvent => {
          if (progressEvent.lengthComputable) {
            this.uploadTask.update(parseInt(progressEvent.loaded / progressEvent.total, 10) * 100);
          }
          if ((progressEvent.loaded / progressEvent.total) === 1) {
            // finished upload
          }
        }
      }).then(response => {
        this.showFolderCreateModal = false;
        this.showFolderUploadModal = false;
        this.loadStillsFolders()
        this.new_stills_folder_name = ""

        this.formData = new FormData();
        this.filesData = [];
        this.filesNames = [];
        document.getElementById("inputStillFolder").value = "";
        this.uploadTask.done();
      }).catch(err => {
        this.uploadTask.error();
      });
    },
    renderStillLightbox(still) {
      this.selected_still = still;
      this.showLightbox = true

    },
    sendStills(peerId) {
      messageBroker.sendCommand('set_stills', peerId, this.stills)
    },
    setStills(stills) {
      this.stills = stills;
    },
    deleteStillFolder(folderId) {
      axios.delete('/library/folder/stills/' + folderId, {
        headers: {'Accept': 'application/json'},
        data: {'authenticity_token': authenticity_token}
      }).then(response => {
        localNotify('Sills folder was deleted successfully', 'success')
        this.selected_stills = 'none';
        this.showDeleteConfirmation = false;
        this.stills = [];
        // update list of folders
        this.loadStillsFolders();
      }).catch(error =>
          console.log(error)
      )
    },
    presentStill(){
      this.presentationMode = true;
      commandsManager.sendAllCommand('show_still', { still: this.selected_still } );
    },
    showStill(still){
      this.renderStillLightbox(still);
    },
    hideStills(){
      this.showLightbox = false;
    },
    closeLightbox(){
      if(this.presentationMode == true){
        commandsManager.sendAllCommand('hide_stills');
      }
      this.showLightbox = false;
      this.presentationMode = false;
    },
    getCurrentFolder(){
      let folder = this.stills_folders.find(x => x.id === this.selected_stills)
      if (folder == null) return;
      return folder.name;
    }
  },
  mounted() {
    // Defer a bit the loading to not overload the client at first
    window.setTimeout(()=>{
      if (this.isDirector == false) this.loadStillsFolders();
    }, 5000)
    this.$root.$on('roomActivated', () => {
      this.roomActivated = true;
      // only reset folder id if the selected_stills is not demo folder
      if (this.getCurrentFolder() == 'Demo folder'){
        this.selected_stills = 'none';
        this.loadStills()
      }
    })

    // register commands
    commandsManager
      .registerNewCommand('show_still', (data) => {
        this.$emit('requestFocus', true)
        this.showStill(data.args.still);
        // if the user is in fullscreen close the fullscreen
        // chrome and safari
        document.webkitCancelFullScreen && document.webkitCancelFullScreen();
        // firefox
        document.mozCancelFullScreen && document.mozCancelFullScreen();
        // ie 
        document.msExitFullscreen && document.msExitFullscreen();
        
      })
      .registerNewCommand('hide_stills', () => {
        this.hideStills();
      })
      .registerNewCommand('set_stills', (data) => {
        console.log("[Stills] Stills have been updated!")
        this.setStills(data.args);
      });

    this.ultraWide = this.$el.clientWidth > 1200;
	  $(window).on('resize', () => {
    		this.ultraWide = this.$el.clientWidth > 1200;
	  })
  },
   watch: {
	isMirrorPlus: function(val, oldVal){
	this.ultraWide = this.$el.clientWidth > 1200;
     }
   },
  computed: {
    uploadStillValidations() {
      // if this.preview_upload is set it means that a file is loaded
      return this.new_still_name.length > 0 && this.preview_upload && this.selected_stills != "none" && this.fileSizeInvalid == false;
    },
    createFolderValidations() {
      // if this section has more than 3 character is valid name
      return this.new_stills_folder_name.length > 0
    }
  }
}
</script>
<style lang="css">

.grid-cols-20 {
    grid-template-columns: repeat(20, minmax(0, 1fr));
}

@media (min-width: 768px) {
.min-h-screen-6\/10{
min-height: 60vh;
}
}
.max-h-screen-8\/10{
max-height: 80vh;
}

</style>